export const VIEWABLE_LENDER_ITEMS = [
  "appraisal_ordered", 
  "appraisal_approved", 
  "title_requested", 
  "title_verified", 
  "title_cleared", 
  "insurance_verified"
];

export const APPRAISAL_ITEMS = ["appraisal_ordered", "appraisal_approved"];
export const TITLE_ITEMS = ["title_requested", "title_verified", "title_cleared"];
export const INSURANCE_ITEMS = ["insurance_verified"];